var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "palletTable", staticStyle: { width: "66.3%" } },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            script: "",
            "max-height": "600px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "totalPalletQty",
              label: _vm.$t("BusinessPurchaseOrder3.Total"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("p", [
                      _c("span", { staticClass: "red" }, [_vm._v("*")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("BusinessPurchaseOrder3.Total"))
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "totalPalletQty" } },
                      [
                        _c("BjInputNumber", {
                          attrs: { placeholder: _vm.$t("inputText") },
                          model: {
                            value: row.totalPalletQty,
                            callback: function ($$v) {
                              _vm.$set(row, "totalPalletQty", $$v)
                            },
                            expression: "row.totalPalletQty",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "csgPallet",
              label: _vm.$t("BusinessPurchaseOrder3.Hire"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("p", [
                      _c("span", { staticClass: "red" }, [_vm._v("*")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("BusinessPurchaseOrder3.Hire"))
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "csgPallet" } },
                      [
                        _c("BjInputNumber", {
                          attrs: { placeholder: _vm.$t("inputText") },
                          model: {
                            value: row.csgPallet,
                            callback: function ($$v) {
                              _vm.$set(row, "csgPallet", $$v)
                            },
                            expression: "row.csgPallet",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                label: _vm.$t("BusinessPurchaseOrder3.CustomerPalletQty"),
                align: "center",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "standardPallet",
                  label: _vm.$t("BusinessPurchaseOrder3.Standard"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("p", [
                          _c("span", { staticClass: "red" }, [_vm._v("*")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("BusinessPurchaseOrder3.Standard"))
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "standardPallet" } },
                          [
                            _c("BjInputNumber", {
                              attrs: { placeholder: _vm.$t("inputText") },
                              model: {
                                value: row.standardPallet,
                                callback: function ($$v) {
                                  _vm.$set(row, "standardPallet", $$v)
                                },
                                expression: "row.standardPallet",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "chepPallet",
                  label: _vm.$t("BusinessPurchaseOrder3.Chep"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("p", [
                          _c("span", { staticClass: "red" }, [_vm._v("*")]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("BusinessPurchaseOrder3.Chep"))
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "chepPallet" } },
                          [
                            _c("BjInputNumber", {
                              attrs: { placeholder: _vm.$t("inputText") },
                              model: {
                                value: row.chepPallet,
                                callback: function ($$v) {
                                  _vm.$set(row, "chepPallet", $$v)
                                },
                                expression: "row.chepPallet",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "loscomPallet",
                  label: _vm.$t("BusinessPurchaseOrder3.Loscom"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("p", [
                          _c("span", { staticClass: "red" }, [_vm._v("*")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("BusinessPurchaseOrder3.Loscom"))
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "loscomPallet" } },
                          [
                            _c("BjInputNumber", {
                              attrs: { placeholder: _vm.$t("inputText") },
                              model: {
                                value: row.loscomPallet,
                                callback: function ($$v) {
                                  _vm.$set(row, "loscomPallet", $$v)
                                },
                                expression: "row.loscomPallet",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nonStandardPallet",
                  label: _vm.$t("BusinessPurchaseOrder3.nonStandard"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("p", [
                          _c("span", { staticClass: "red" }, [_vm._v("*")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("BusinessPurchaseOrder3.nonStandard")
                              )
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "nonStandardPallet" } },
                          [
                            _c("BjInputNumber", {
                              attrs: { placeholder: _vm.$t("inputText") },
                              model: {
                                value: row.nonStandardPallet,
                                callback: function ($$v) {
                                  _vm.$set(row, "nonStandardPallet", $$v)
                                },
                                expression: "row.nonStandardPallet",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }